// Curated mental health resources (trusted external links).
export const RESOURCES = [
  {
    category: "Anxiety & Stress Resources",
    description:
      "Helpful information and support related to anxiety, panic attacks, stress management, and emotional regulation.",
    links: [
      { name: "Anxiety & Depression Association of America (ADAA)", url: "https://adaa.org/" },
      {
        name: "National Institute of Mental Health – Anxiety Disorders",
        url: "https://www.nimh.nih.gov/health/topics/anxiety-disorders",
      },
      { name: "Mindful – Mindfulness & Meditation Resources", url: "https://www.mindful.org/" },
    ],
  },
  {
    category: "OCD & Exposure Therapy Resources",
    description:
      "Educational resources related to OCD, intrusive thoughts, compulsions, and exposure-based treatment approaches.",
    links: [
      { name: "International OCD Foundation (IOCDF)", url: "https://iocdf.org/" },
      {
        name: "ADAA – OCD Information",
        url: "https://adaa.org/understanding-anxiety/obsessive-compulsive-disorder-ocd",
      },
      {
        name: "NIMH – Obsessive-Compulsive Disorder",
        url: "https://www.nimh.nih.gov/health/topics/obsessive-compulsive-disorder-ocd",
      },
    ],
  },
  {
    category: "Depression & Mood Support",
    description: "Resources focused on depression, mood disorders, emotional wellness, and self-care.",
    links: [
      {
        name: "National Institute of Mental Health – Depression",
        url: "https://www.nimh.nih.gov/health/topics/depression",
      },
      { name: "National Alliance on Mental Illness (NAMI)", url: "https://www.nami.org/" },
      { name: "Mental Health Information – NIMH", url: "https://www.nimh.nih.gov/health" },
    ],
  },
  {
    category: "Trauma & PTSD Resources",
    description: "Educational information related to trauma, PTSD, emotional healing, and recovery.",
    links: [
      { name: "National Center for PTSD", url: "https://www.ptsd.va.gov/" },
      {
        name: "NIMH – Coping With Traumatic Events",
        url: "https://www.nimh.nih.gov/health/topics/coping-with-traumatic-events",
      },
      { name: "Mental Health America – Trauma Resources", url: "https://mhanational.org/conditions/trauma" },
    ],
  },
  {
    category: "Relationship & Couples Support",
    description:
      "Resources related to communication, healthy relationships, conflict resolution, and emotional connection.",
    links: [
      { name: "The Gottman Institute", url: "https://www.gottman.com/" },
      { name: "Prepare/Enrich Relationship Resources", url: "https://www.prepare-enrich.com/" },
      { name: "Love Is Respect", url: "https://www.loveisrespect.org/" },
    ],
  },
  {
    category: "Domestic Violence & Abuse Support",
    description:
      "Confidential support and resources for individuals experiencing domestic violence, emotional abuse, or unhealthy relationship dynamics.",
    links: [
      { name: "National Domestic Violence Hotline", url: "https://www.thehotline.org/" },
      { name: "Women Aware NJ", url: "https://womenaware.net/" },
      { name: "Love Is Respect", url: "https://www.loveisrespect.org/" },
    ],
  },
  {
    category: "Child & Teen Mental Health",
    description: "Supportive resources for parents, caregivers, children, and adolescents.",
    links: [
      { name: "Child Mind Institute", url: "https://childmind.org/" },
      {
        name: "American Academy of Child & Adolescent Psychiatry (AACAP)",
        url: "https://www.aacap.org/",
      },
      { name: "NAMI", url: "https://www.nami.org/" },
    ],
  },
  {
    category: "Grief & Loss Support",
    description: "Resources related to grief, bereavement, and coping with loss.",
    links: [
      { name: "What's Your Grief", url: "https://whatsyourgrief.com/" },
      {
        name: "Dougy Center – Grief Support for Children & Families",
        url: "https://www.dougy.org/",
      },
      { name: "Crisis Text Line", url: "https://www.crisistextline.org/" },
    ],
  },
  {
    category: "Substance Use & Recovery Resources",
    description: "Support and education related to substance use, addiction, and recovery.",
    links: [
      { name: "SAMHSA National Helpline", url: "https://www.samhsa.gov/find-help/national-helpline" },
      { name: "Alcoholics Anonymous (AA)", url: "https://www.aa.org/" },
      { name: "Narcotics Anonymous (NA)", url: "https://na.org/" },
    ],
  },
  {
    category: "Crisis & Immediate Support",
    description:
      "If you or someone you know is experiencing a mental health crisis, immediate support is available.",
    isCrisis: true,
    links: [
      {
        name: "988 Suicide & Crisis Lifeline — Call or text 988 for free 24/7 confidential support.",
        url: "https://988lifeline.org/",
      },
      {
        name: "Crisis Text Line — Text HOME to 741741 to connect with a trained crisis counselor.",
        url: "https://www.crisistextline.org/",
      },
      {
        name: "Call 911 or visit your nearest emergency room if you are in immediate danger or require urgent medical attention.",
        url: "tel:911",
      },
    ],
  },
  {
    category: "Psychoeducation & Mental Health Information",
    description:
      "Reliable educational information about mental health conditions, treatment approaches, and emotional wellness.",
    links: [
      { name: "National Institute of Mental Health (NIMH)", url: "https://www.nimh.nih.gov/" },
      { name: "National Institutes of Health (NIH)", url: "https://www.nih.gov/" },
      { name: "Mental Health America", url: "https://mhanational.org/" },
    ],
  },
];
